<template>
  <div class="row">
    <div class="col-md-12 text-center">
      <div>
        <h1>{{ $t('portal.sorryAboutThat') }}</h1>
        <h3>{{ $t('portal.pageNotFound') }}</h3>
        <div>
          {{ $t('portal.notFoundDetails') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "NotFound"
  }
</script>

<style scoped>

</style>
